
        'use strict';
        import {getSessionTimeoutParams,getBackendSystem, getChosenKeepMeSignInConf} from "../appConfig/appConfigForward";

        var angular:angular.IAngularStatic =  require('angular');
        angular.module('primo-explore.security')
            .factory('SessionTimeoutService',SessionTimeoutService);
        function SessionTimeoutService(Idle) {
            let service = {
                // Add your functions here
                // parseItem:parseItem
                isSessionExpired: isSessionExpired,
                startSession: startSession,
                updateSessionTimeoutTime: updateSessionTimeoutTime
            };
            return service;




            function startSession(isGuest){
                let sessionTimeoutParams = getSessionTimeoutParams();
                let chosenConf = getChosenKeepMeSignInConf();

                // For signed in user
                if (!isGuest){  
                    if(getBackendSystem() !== 'suprima'){
                        /*we decided not to have a  ui timeout for signed in users. Once the Java session dies the server will perform silent logout.
                        Then when we make a request to the server the WsXsIpFilter will respond with 401 and we will be logged out in the UI by the response error listener */
                        Idle.unwatch();
                        return;
                    }else{
                        let sessionTimeoutInSeconds = sessionTimeoutParams.userSessionTimeout * 60;

                        // In order to catch and pop up 60 seconds before the session times out
                        if(chosenConf != null && (chosenConf == 'extend' || chosenConf == 'extend_max')){
                            sessionTimeoutInSeconds = sessionTimeoutInSeconds - 60;
                        }

                        if(sessionTimeoutInSeconds && sessionTimeoutInSeconds > 0){
                            Idle.setIdle(sessionTimeoutInSeconds);
                            Idle.watch();  // Starts watching for idleness, or resets the idle/warning state and continues watching
                        }
                        return;
                    }
                }
                 // For Guest
                let sessionTimeoutInSeconds = (isGuest? sessionTimeoutParams.guestSessionTimeout : sessionTimeoutParams.userSessionTimeout) * 60;
                if (sessionTimeoutInSeconds && sessionTimeoutInSeconds > 0){
                    Idle.setIdle(sessionTimeoutInSeconds);
                    Idle.watch();
                }
                else{
                    Idle.unwatch();
                }
            }

            function isSessionExpired() {
                return Idle.isExpired();
            }

            function updateSessionTimeoutTime(time){
                let chosenConf = getChosenKeepMeSignInConf();
                if(chosenConf != null && (chosenConf == 'extend' || chosenConf == 'extend_max')){
                    time = time - 60;
                }
                if(time > 0){
                    Idle.setIdle(time);	   // Updates the idle value and restarts the watch if its running
                }  
            }

        }
        SessionTimeoutService.$inject = ['Idle', '$state'];



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/sessionTimeout.service.ts